import React from 'react'
import ManageBooksDetail from '../manage-books/ManageBooksDetail';
import { ELibraryCategory } from '../../enum/elibrary_enum';
import { routeName } from '../../../../routes/routeName';
import { useTranslation } from 'react-i18next';

type Props = {
    view: boolean;
}

const ManagePodcastDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    return (
        <ManageBooksDetail
            library_category_name={ELibraryCategory.PODCAST}
            view={view}
            menu_name={t('จัดการพอดแคสต์')}
            menu_name_detail={t("เพิ่มพอดแคสต์")}
            menu_name_detail_edit={t("รายละเอียดพอดแคสต์")}
            menu_path_name={routeName.e_library.manage_podcast}
        />
    )
}

export default ManagePodcastDetail